import wordpressAJAX from "./wp-ajax";
import {searchCompany} from "./brreg";

export function checkoutFile() {
  document.querySelectorAll('form.woocommerce-checkout .file-field input[type="file"]').forEach((input) => {
    input.addEventListener('change', (event) => {
      if(!event.target.files || event.target.files.length === 0) {
        return;
      }
      if(event.target.files.length !== 1) {
        return;
      }

      const formData = new FormData();
      formData.append( 'customer_file', event.target.files[0] );

      wordpressAJAX(wc_add_to_cart_params.ajax_url, 'customer_upload_file', {
        'customer_file': event.target.files[0],
      }, true)
        .then(response => {
          event.target.parentElement.querySelector(`input[name="${event.target.name}_field"`).value = response?.data;
        })
        .catch(error => {
          console.error('Error:', error);
        });
    });
  });
}

export function microCartRemoveItem() {
  document.querySelectorAll('.woocommerce-micro-cart-item .remove').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      //wordpressAJAX(wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'remove_from_cart'), 'remove_from_cart', data)
      wordpressAJAX(wc_add_to_cart_params.ajax_url, 'remove_from_micro_cart', {
        'cart_item_key': button.dataset.cart_item_key,
      })
        .then(response => {
          if(!response.data || response.data.length === 0) {
            window.location.reload();
            //window.location.href = wc_add_to_cart_params.cart_url;
            return;
          }
          document.querySelectorAll('.woocommerce-micro-cart-item').forEach((item) => {
            let itemKey = item.querySelector('[data-cart_item_key]')?.dataset.cart_item_key;
            // remove item where itemkey not in response.data
            if(!response.data.includes(itemKey)) {
              item.remove();
            }
          });
          // Update the cart fragments
          //jQuery(document.body).trigger('removed_from_cart', [response.fragments, response.cart_hash, jQuery(button)]);
          jQuery(document.body).trigger('wc_fragment_refresh');
        })
        .catch(error => {
          console.error('Error:', error);
        });
    });
  });
}

export function directInquiry() {
   document.querySelectorAll('button[name="add-to-cart-direct"]').forEach((button) => {
    button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = document.querySelector('form.cart');
    if(!form) {
      return;
    }

    const formData = new FormData(form);
    wordpressAJAX(wc_add_to_cart_params.ajax_url, 'direct_inquiry', {
      'product_id': event.target.value,
      'quantity': 1,
      ...Object.fromEntries(formData.entries()),
    }, true)
      .then(response => {
        const dialog = document.createElement('dialog');
        dialog.setAttribute('class', 'direct-inquiry-response');
        dialog.setAttribute('open', 'open');
        
        const innerDialog = document.createElement('div');
        innerDialog.setAttribute('class', 'inner-dialog');
        innerDialog.innerHTML = response.data.checkout;

        const closeButton = document.createElement('button');
        closeButton.setAttribute('class', 'close');
        closeButton.innerHTML = 'X';
        innerDialog.appendChild(closeButton);

        const secondaryCloseButton = document.createElement('button');
        secondaryCloseButton.setAttribute('class', 'close textual');
        secondaryCloseButton.innerHTML = 'Legg til flere produkter';
        innerDialog.appendChild(secondaryCloseButton);

        const note = document.createElement('div');
        note.setAttribute('class', 'note');
        note.innerHTML = 'Du hører fra oss innen 24 timer.';
        innerDialog.appendChild(note);

        dialog.appendChild(innerDialog);
        document.body.appendChild(dialog);

        dialog.querySelectorAll('button.close').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            dialog.remove();
          });
        });

        microCartRemoveItem();
        checkoutFile();
        searchCompany();
        attemptStoringCustomerDetails();

        if(!response.data || response.data.length === 0) {
          //window.location.reload();
          window.location.href = wc_add_to_cart_params.cart_url;
          return;
        }
        //jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, jQuery(button)]);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  });
   });
}

export function attemptStoringCustomerDetails() {
  if(! window.localStorage ) return; // Check if localStorage is available
  if(!document.querySelector('form.woocommerce-checkout')) {
    return; // No checkout form found, nothing to do
  }
  const fields = document.querySelectorAll('input[name^="billing_"]');
  if(fields.length === 0) {
    return; // No billing fields found, nothing to do
  }

  fields.forEach((input) => {
    if(input.value) {
      window.localStorage.setItem(input.name, input.value);
    } else {
      maybeSetInputValue(input, window.localStorage.getItem(input.name));
    }
    input.addEventListener('change', (event) => {
      window.localStorage.setItem(event.target.name, event.target.value);
    });
  });
}

function maybeSetInputValue(input, value) {
  if(input && input.value === '' && value) {
    input.value = value;
  }
}